import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';

import * as style from './style.module.css';

const ScrollableList = ({ className = '', children, shadow = 'var(--comp-scrollablelist-background-color)', arrowSpace = '0px' }) => {
  const scrollRef = useRef(null);
  const [actionsState, setActionState] = useState({ left: true, right: false, height:0 });

  const handleClickMore = useCallback(() => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft += scrollRef?.current?.clientWidth - 60;
    }
  }, []);

  const handleClickLess = useCallback(() => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft -= scrollRef?.current?.clientWidth - 60;
    }
  }, []);

  useLayoutEffect(() => {
    const elem = scrollRef?.current;
    if (!elem) {
      return;
    }

    const handleScroll = () => {
      const elem = scrollRef?.current;
      if (!elem) {
        return;
      }
      const left = elem?.scrollLeft <= 1;
      const right = elem?.scrollLeft >= elem?.scrollWidth - elem?.clientWidth - 1;
      const height = Math.ceil(elem?.getBoundingClientRect()?.height || 0);
      setActionState({ left, right, height });
    };

    handleScroll();
    elem?.addEventListener('scroll', handleScroll);
    window?.addEventListener('resize', handleScroll);
    window?.addEventListener('zoom', handleScroll);
    return () => {
      elem?.removeEventListener('scroll', handleScroll);
      window?.removeEventListener('resize', handleScroll);
      window?.removeEventListener('zoom', handleScroll);
    };
  }, [scrollRef]);

  return (
    <div className={`${style.list} ${className}`} style={{ '--shadow-height': `${actionsState.height}px`, '--arrow-space': arrowSpace }}>
      <div className={style.scrollable} ref={scrollRef}>
        {children}
      </div>
      <div className={`${style.shadow} ${style.less} ${actionsState.left ? style.hide : ''}`} style={{ background: `linear-gradient(-90deg, rgb(0 0 0 / 0%) 0%, ${shadow} 100%)` }}>
        <FontAwesomeIcon icon={faChevronLeft} onClick={handleClickLess} />
      </div>
      <div className={`${style.shadow} ${style.more} ${actionsState.right ? style.hide : ''}`} style={{ background: `linear-gradient(90deg, rgb(0 0 0 / 0%) 0%, ${shadow} 100%)` }}>
        <FontAwesomeIcon icon={faChevronRight} onClick={handleClickMore} />
      </div>
    </div>
  );
};

export default ScrollableList;
